import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-2xl font-bold text-white">GR. PROSPERITY</span>
              <span className="text-2xl font-bold text-orange-500">| Expats</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Your trusted partner for comprehensive financial planning and relocation support in Germany. Expert guidance in English for all your financial matters.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3 text-sm">
                <Mail className="w-4 h-4 text-orange-500" />
                <a href="mailto:kontakt@gr-prosperity.de" className="hover:text-orange-500 transition-colors">
                  kontakt@gr-prosperity.de
                </a>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <Phone className="w-4 h-4 text-orange-500" />
                <a href="tel:+498105775720" className="hover:text-orange-500 transition-colors">
                  +49 8105 7757206
                </a>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <MapPin className="w-4 h-4 text-orange-500" />
                <span>Am Hochacker 48, 81827 München</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => {
                    const el = document.getElementById('services');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-orange-500 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const el = document.getElementById('hr-section');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-orange-500 transition-colors"
                >
                  For Companies
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const el = document.getElementById('process');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-orange-500 transition-colors"
                >
                  Process
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const el = document.getElementById('faq');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-orange-500 transition-colors"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-orange-500 transition-colors cursor-pointer">Finance & Banking</li>
              <li className="hover:text-orange-500 transition-colors cursor-pointer">Insurance Solutions</li>
              <li className="hover:text-orange-500 transition-colors cursor-pointer">Wealth Building</li>
              <li className="hover:text-orange-500 transition-colors cursor-pointer">Real Estate Investment</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} GR. PROSPERITY. All Rights Reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a
                href="https://gr-prosperity.de/datenschutzerklaerung/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-orange-500 transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="https://gr-prosperity.de/impressum/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-orange-500 transition-colors"
              >
                Impressum
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
